import { useState } from "react";
import { baseUrl } from "../../helper/baseUrl";
import { useAuth } from "../../user/context/AuthContext";
import useCustomSnackbar from "../../helper/useCustomSnackbar";

const useLogin = (url) => {

  const apiUrl = baseUrl();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login } = useAuth();
  const showSnakbar = useCustomSnackbar()

  const handleLogin = async (data) => {
    console.log("data", data)
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${apiUrl}/${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
      });
      console.log("response", response);

      if (!response.ok) {
        console.log("!response.ok", !response.ok);
        const errorData = await response.json();
        const errorText = errorData.message || "Login failed"; // Extract the error message properly
        showSnakbar("error", errorText);
        throw new Error(errorText || "Login failed");
      }

      const token = await response.text();
      if (!token) {
        throw new Error("Invalid token received");
      }
      localStorage.setItem("token", token);
      login(token);
      if (url === 'auth/signup') {
        showSnakbar("success", localStorage.getItem("token"));
      }
      else if (url === 'auth/forgot-password') {
        showSnakbar("success", "Reset Link has been sent successfully");
      }
      else {
        showSnakbar("success", "Logged in successfully");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError(error.message);
      // showSnakbar("error", "error.message");
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading, error, handleLogin];
};

export default useLogin;
